import React, { useEffect, useState } from 'react'
import { CorteOrders, CorteDeposits } from '../../AdminClasses'
import { Button, Header, Pagination, Table, Modal } from 'react-frontier2'
import { Link } from 'react-router-dom'
import { addCommas, fromUnix } from '@arema/components/Util'
import { useTranslation } from 'react-i18next'
import API from '../../API'
import { Money } from '@arema/components'

export interface CorteDetailModalProps{
	corte_id: number,
	open: boolean,
	onClose: ()=>void,
}

const PAGE_SIZE = 50;
var CorteDetailModal = (props: CorteDetailModalProps)=>{
	var { t } = useTranslation();
	var [orders, setOrders] = useState<CorteOrders[]>(null)
	var [pageOrders, setPageOrders] = useState<number>(0);
	var [loadError, setLoadError] = useState<string>(null);
	var [deposits, setDeposits] = useState<CorteDeposits[]>(null);
	var [pageDeposits, setPageDeposits] = useState<number>(0);
	var [data, setData] = useState<{ order_count: number, total: number }>(null);

	useEffect(()=>{
		if(props.open) {
			loadData(pageOrders, pageDeposits);
		}else{
			setDeposits(null);
			setOrders(null);
			setData(null);
			setLoadError(null);
		}
	}, [props.corte_id, props.open])

	var loadData = async (pageOrders: number, pageDeposits: number)=>{
		setLoadError(null);
		API.getPdvCorteDetail(props.corte_id, !data, pageDeposits * PAGE_SIZE, PAGE_SIZE, pageOrders * PAGE_SIZE, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			if(!data){
				setData({
					order_count: res.data.order_count,
					total: res.data.total,
				});
			}
			setOrders(res.data.orders);
			setDeposits(res.data.deposits);
		}).catch(err=>{
			setLoadError('Error inesperado cargando las ordenes (LCL-1)');
		})
	}

	var onPageOrdersChange = (page: number)=>{
		setPageOrders(page);
		loadData(page, pageDeposits)
	}

	var onPageDepositsChange = (page: number)=>{
		setPageDeposits(page);
		loadData(pageOrders, page);
	}

	var hasNext = orders?.length >= PAGE_SIZE;
	return <Modal open={props.open} onClose={props.onClose} size='large'>
		<Modal.Header>Corte {props.corte_id}</Modal.Header>
		<Modal.Content style={{ padding: 0 }}>
			{loadError ? (
				<Header text='Error' subtext={loadError} style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
			) : (!orders || !deposits) ? (
				<div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<Header text='Cargando corte' loading />
				</div>
			) : <>
				<Table style={{ margin: 'auto', borderRadius: 0, boxShadow: 'none' }}>
					<Table.Head
						title='Depositos'
						data={[['ID', 'Fecha', 'Información', 'Cantidad']]}
						collapsingIndexes={[0, 1, 3]}
					/>
					<Table.Body>
						{deposits.length===0 && (
							<Table.Cell empty row colSpan={100} value={'Este corte no tiene depositos agregados'} />
						)}
						{deposits.map(dep=>(
							<Table.Row
								key={dep.deposit_id}
								collapsingIndexes={[0, 1, 3]}
								data={[
									dep.deposit_id,
									fromUnix(dep.date_deposit).toFormat('dd/MM/yyyy HH:mm'),
									dep.description,
									<Money value={dep.amount} />
								]}
							/>
						))}
					</Table.Body>
					<Table.Footer actions={(
						<Pagination inline page={pageDeposits} onPageChange={onPageDepositsChange} hasNext={hasNext} />
					)} />
				</Table>
				<Table style={{ margin: 'auto', borderRadius: 0, boxShadow: 'none', borderTop: '1px solid #eeeeee' }}>
					<Table.Head title='Ordenes' />
					<Table.Body>
						<Table.Row>
							<Table.Cell colSpan={2} style={{ fontWeight: 'bold' }}>{t('common.total')}</Table.Cell>
							<Table.Cell colSpan={4} style={{ textAlign: 'right' }}>{data.order_count} {t('common.orders', { count: data.order_count })}</Table.Cell>
							<Table.Cell><Money value={data.total} /></Table.Cell>
						</Table.Row>
						<Table.Row header collapsingIndexes={[0, 1, 3, 4, 5, 6]} data={['ID', 'Calendario', 'Evento', 'Usuario', 'Fecha', 'Forma Pago', 'Total']} />
						{orders.length===0 && (
							<Table.Cell empty row colSpan={100} value={'Este corte no tiene ordenes'} />
						)}
						{orders.map(ord=>(
							<Table.Row key={`CRTOR-${ord.order_id}`} collapsingIndexes={[0, 1, 3, 4, 5, 6]}>
								<Table.Cell compact collapsing as={Link} to={`/orders/@${ord.order_id}`} target="_blank">
									<span style={{ color: '#4183c4' }} >{ord.order_id}</span>
								</Table.Cell>
								<Table.Cell collapsing>{ord.date_id}</Table.Cell>
								<Table.Cell>{ord.event_name}</Table.Cell>
								<Table.Cell collapsing>{ord.user_creator_name}</Table.Cell>
								<Table.Cell collapsing>{fromUnix(ord.date_created).toFormat('dd/MM/yyyy HH:mm')}</Table.Cell>
								<Table.Cell collapsing>{ord.payment_method_name}</Table.Cell>
								<Table.Cell collapsing ><Money value={ord.total} /></Table.Cell>
							</Table.Row>
						))}
					</Table.Body>
					<Table.Footer actions={(
						<Pagination inline page={pageOrders} pageCount={data ? Math.ceil(data.order_count/PAGE_SIZE) : null } onPageChange={onPageOrdersChange} hasNext={hasNext} />
					)} />
				</Table>
			</>}
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' color='black' onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default CorteDetailModal;